common.View.create('canvas.blocks.sky.sliderBravo.Block', {

    onDOMLoad() {
        this.initSlider();
        this.initReadMore();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: true,
            dots: true,
            nav: false,
            autoplay: !this.element.is('[data-canvas-editable]'),
            autoplayTimeout: 10000,
            autoplayHoverPause: true,
            items: 1,
        });
    },

    initReadMore() {
        var self = this;

        // Reveal the toggle on quotes that overflow the 5-line clamp. Reveal-only
        // (never hides) so re-runs are safe and an expanded slide keeps its button.
        var reveal = function () {
            self.element.find('.item').each(function () {
                var quote = this.querySelector('.quote-clamp > *');
                if (quote && quote.scrollHeight - quote.clientHeight > 1) {
                    jQuery(this).find('.quote-toggle').removeClass('hidden');
                }
            });
        };

        reveal();

        // iOS Safari first paints in the fallback font, which can fit inside the
        // clamp and hide a genuine overflow — re-check once the web font (Lexend)
        // and full layout have settled.
        if (window.document.fonts && window.document.fonts.ready) {
            window.document.fonts.ready.then(reveal);
        }
        jQuery(window).on('load', reveal);

        // Delegated so owl's cloned loop slides toggle too; expanding grows the
        // slide via normal reflow (the carousel has no fixed height).
        this.element.on('click', '.quote-toggle', function () {
            var toggle = jQuery(this);
            var expanded = toggle.closest('.item').toggleClass('is-expanded').hasClass('is-expanded');
            toggle.attr('aria-expanded', expanded).text(expanded ? 'Lees minder' : 'Lees meer');
        });
    }
});
